module.exports = __webpack_public_path__ + "img/oborudovanie-dlja-sto.759dac2f.svg";